import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { PhoneNumberHelper } from '../../../../../helper/phone-number.helper';
import { LeadDataObject, LeadsData, LeadType } from '../../../../../models/leads/leads.model';
import { Router } from '@angular/router';
import { AddressHelper } from '../../../../../helper/address.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from "../../../../../services/leads/leads-data.service";
import { TextHelper } from '../../../../../helper/text.helper';

@Component({
  selector: 'fi-search-additionary',
  templateUrl: './search-additionary.component.html',
  styleUrls: ['./search-additionary.component.scss'],
  standalone: false,
})
export class SearchAdditionaryComponent implements OnInit, OnChanges {
  highlightedSearchStatusDocument = [];
  highlightedSearchContact = [];
  highlightedSearchCommission = [];
  private leadTypes: LeadType[] = [];
  private static map = new WeakMap<LeadsData, SearchAdditionaryComponent>();

  static isVisible(lead: LeadsData): boolean {
    const component = this.map.get(lead);

    if (component) {
      return !!component.showContentAddresses ||
             !!component.showDetailContent ||
             !!component.highlightedDocuments?.length ||
             !!component.highlightedNotes?.length;
    }
    return false;
  }

  constructor(
    private router: Router,
    @Inject(LEADS_DATA_SERVICE) private leadDataService: LeadsDataService,
  ) {
  }

  @Input() Lead: LeadsData;
  showDetailContent = false;
  showContentAddresses = false;
  highlightedDocuments: string[] = [];
  highlightedNotes: string[] = [];

  ngOnInit(): void {
    this.update();
  }

  ngOnChanges(): void {
    this.update();
  }

  private update(): void {
    if (this.Lead) {
      SearchAdditionaryComponent.map.set(this.Lead, this);
    }

    this.searchContactData();
    this.searchContactAdress();
    this.searchContactDocument();
    this.searchStatusDocument();
    this.searchLeadsContact();
    this.searchLeadsCommission();
    this.searchContactNote();
  }

  searchContactData(): void {
    const searchedValue = this.router.parseUrl(this.router.url).queryParamMap.get('q')?.toLowerCase();
    const contact = this.Lead.Lead.Contact;
    const categoryValue = this.router.parseUrl(this.router.url).queryParamMap.get('n');

    if (!categoryValue || categoryValue === "Contact") {
      if (contact?.Email && contact?.Email.toLowerCase().includes(searchedValue) && !contact?.Email?.endsWith('@temp.finstral.com')) {
        this.showDetailContent = true;
      } else if (contact?.AdditionalEmail && contact?.AdditionalEmail.toLowerCase().includes(searchedValue) && !contact?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
        this.showDetailContent = true;
      } else if ((this.contactPhone && this.contactPhone.includes(searchedValue)) || (this.contactMobile && this.contactMobile.includes(searchedValue))) {
        this.showDetailContent = true;
      }
    }
  }

  searchContactAdress(): void {
    const searchedValue = this.router.parseUrl(this.router.url).queryParamMap.get('q')?.toLowerCase();
    const categoryValue = this.router.parseUrl(this.router.url).queryParamMap.get('n');

    if (!categoryValue || categoryValue === "Address") {
      if (!!AddressHelper.getLeadAddress(this.Lead.Lead.Address) && !!this.getAddress(this.Lead.Lead).toLowerCase().includes(searchedValue)) {
        this.showContentAddresses = true;
      } else {
        this.showContentAddresses = false;
      }
    }
  }

  searchLeadsContact(): void {
    if (!this.Lead.Highlights) {
      return
    }
    const searchedValue = this.router.parseUrl(this.router.url).queryParamMap.get('contact')?.toLowerCase();
    if (searchedValue) {
      if (this.Lead.Highlights['Contact.FirstName']?.length) {
        this.highlightedSearchContact = this.highlightedSearchContact.concat(this.Lead.Highlights['Contact.FirstName']?.map(name => {
          return TextHelper.decodeHtml(name);
        }));
      }
      if (this.Lead.Highlights['Contact.LastName']?.length) {
        this.highlightedSearchContact = this.highlightedSearchContact.concat(this.Lead.Highlights['Contact.LastName']?.map(name => {
          return TextHelper.decodeHtml(name);
        }));
      }
    }
    this.highlightedSearchContact = this.highlightedSearchContact.filter(item => item);
  }

  searchLeadsCommission(): void {
    if (!this.Lead.Highlights) {
      return
    }

    const searchedValue = this.router.parseUrl(this.router.url).queryParamMap.get('commission')?.toLowerCase();
    if (searchedValue) {
      this.highlightedSearchCommission = this.highlightedSearchCommission.concat(this.Lead.Highlights['Contact.ZipCode']?.map(name => {
        return TextHelper.decodeHtml(name);
      }));
      this.highlightedSearchCommission = this.highlightedSearchCommission.concat(this.Lead.Highlights['Contact.City']?.map(name => {
        return TextHelper.decodeHtml(name);
      }));

      this.highlightedSearchCommission = this.highlightedSearchCommission.filter(item => item)
    }
  }

  searchContactDocument(): void {
    if (!this.Lead.Highlights) {
      return
    }

    if (this.Lead.Highlights['Documents.Name']?.length) {
      this.highlightedDocuments = this.Lead.Highlights['Documents.Name']?.map(name => {
        return TextHelper.decodeHtml(name);
      });
    }
  }

  searchStatusDocument(): void {
    if (!this.Lead.Highlights) {
      return
    }

    if (this.Lead.Highlights['StatusId']?.length) {
      this.highlightedSearchStatusDocument.push(...this.Lead.Highlights['StatusId']?.map(name => {
        return TextHelper.decodeHtml(name);
      }));
    }
  }

  searchContactNote(): void {
    if (this.Lead.Highlights && this.Lead.Highlights['History.Comment']?.length) {
      this.highlightedNotes = this.Lead.Highlights['History.Comment'].map(name => {
        return TextHelper.decodeHtml(name);
      });
    }
  }

  get contactPhone(): string {
    return PhoneNumberHelper.getPhoneNumber(this.Lead.Lead.Contact?.PhonePrefix, this.Lead.Lead.Contact?.Phone);
  }

  get contactMobile(): string {
    return PhoneNumberHelper.getPhoneNumber(this.Lead.Lead.Contact?.MobilePrefix, this.Lead.Lead.Contact?.Mobile);
  }

  getAddress(lead: LeadDataObject): string {

    const contactCountry = lead.Contact?.CountryText ? lead.Contact?.CountryText + ', ' : '';
    const contactCity = lead.Contact?.City ? lead.Contact?.City + ', ' : '';
    const contactAddress = lead.Contact?.Address ? lead.Contact?.Address + ', ' : '';
    const contactZipCode = lead.Contact?.ZipCode ? lead.Contact?.ZipCode + ' ' : '';
    return contactAddress + contactZipCode + contactCity + contactCountry;
  }
}
